import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import Link from './link';
import { CONSTS } from './_constants';
type CardActionButtonComponentProps = {
    className?:string,
    title?: string,
    iconClassName?: string,
    to?: any,
    href?: string,
    style?:CSSProperties,
    onClick?: any,
    hasBorderRight?: boolean,
    height?: string
}
const CardActionButtonComponent = (props: CardActionButtonComponentProps) => {
    return(
        <Link className={props.className} to={props.to} href={props.href} onClick={props.onClick} style={{...props.style}}>
            {props.iconClassName && <div className={`_icon ${props.iconClassName}`}/>}
            {props.title && <div className="_title">{props.title}</div>}
        </Link>
    )}

const CardActionButton = styled(CardActionButtonComponent)`
        color: ${CONSTS.colors.primary};
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-left: 14px;
        padding-right: 14px;
        height: ${props => props.height ? props.height :"53px"};
        ${props => props.hasBorderRight ? "border-right: 1px solid rgba(63,63,68,0.05);" : ""}
        transition: ease background .25s,ease color .25s;
        ._icon {
            font-size: 16px;
            margin-left: 4px;
        }
        ._title {
            font-size: 14px;
            font-family: ${CONSTS.fonts.primary.regular};
        }
        &:hover {
            background: ${CONSTS.colors.primaryLight};
        }
        &:active {
            background: ${CONSTS.colors.primary};
            color: white;
        }
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            padding-left: 5px;
            padding-right: 5px;
            ._icon{
                font-size: 22px;
            }
            ._title{
                display: none;
            }
        }
`

export default CardActionButton;